import coverImg from '../../../assets/images/literature/sam-mcgee-cover.jpg';

const SEGMENTS = [
    {
        id: 'segment-1',
        title: 'Strange Sights',
        stanzas: [1, 2],
        text: `There are strange things done in the midnight sun
By the men who moil for gold;
The Arctic trails have their secret tales
That would make your blood run cold;
The Northern Lights have seen queer sights,
But the queerest they ever did see
Was that night on the marge of Lake Lebarge
I cremated Sam McGee.

Now Sam McGee was from Tennessee, where the cotton blooms and blows.
Why he left his home in the South to roam 'round the Pole, God only knows.
He was always cold, but the land of gold seemed to hold him like a spell;
Though he'd often say in his homely way that "he'd sooner live in hell."`,
        morseText: '| | | THERE ARE STRANGE THINGS DONE IN THE MIDNIGHT SUN BY THE MEN WHO MOIL FOR GOLD BK THE ARCTIC TRAILS HAVE THEIR SECRET TALES THAT WOULD MAKE YOUR BLOOD RUN COLD BK THE NORTHERN LIGHTS HAVE SEEN QUEER SIGHTS BUT THE QUEEREST THEY EVER DID SEE WAS THAT NIGHT ON THE MARGE OF LAKE LEBARGE I CREMATED SAM MCGEE BK | NOW SAM MCGEE WAS FROM TENNESSEE WHERE THE COTTON BLOOMS AND BLOWS BK WHY HE LEFT HIS HOME IN THE SOUTH TO ROAM ROUND THE POLE GOD ONLY KNOWS BK HE WAS ALWAYS COLD BUT THE LAND OF GOLD SEEMED TO HOLD HIM LIKE A SPELL BK THOUGH HED OFTEN SAY IN HIS HOMELY WAY THAT HED SOONER LIVE IN HELL BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'sam-mcgee-q1',
                question: 'Where was Sam McGee from?',
                options: ['ALASKA', 'TENNESSEE', 'YUKON', 'DAWSON'],
                answer: 'TENNESSEE',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'segment-2',
        title: 'The Dawson Trail',
        stanzas: [3, 4],
        text: `On a Christmas Day we were mushing our way over the Dawson trail.
Talk of your cold! through the parka's fold it stabbed like a driven nail.
If our eyes we'd close, then the lashes froze till sometimes we couldn't see;
It wasn't much fun, but the only one to whimper was Sam McGee.

And that very night, as we lay packed tight in our robes beneath the snow,
And the dogs were fed, and the stars o'erhead were dancing a jig or so,
He turned to me, and "Cap," says he, "I'll cash in this trip, I guess;
And if I do, I'm asking that you won't refuse my last request."`,
        morseText: '| | ON A CHRISTMAS DAY WE WERE MUSHING OUR WAY OVER THE DAWSON TRAIL BK TALK OF YOUR COLD THROUGH THE PARKAS FOLD IT STABBED LIKE A DRIVEN NAIL BK IF OUR EYES WED CLOSE THEN THE LASHES FROZE TILL SOMETIMES WE COULDNT SEE BK IT WASNT MUCH FUN BUT THE ONLY ONE TO WHIMPER WAS SAM MCGEE BK | AND THAT VERY NIGHT AS WE LAY PACKED TIGHT IN OUR ROBES BENEATH THE SNOW AND THE DOGS WERE FED AND THE STARS OERHEAD WERE DANCING A JIG OR SO BK HE TURNED TO ME AND CAP SAYS HE ILL CASH IN THIS TRIP I GUESS AND IF I DO IM ASKING THAT YOU WONT REFUSE MY LAST REQUEST BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'sam-mcgee-q6',
                question: 'On what day did they mush over the Dawson trail?',
                options: ['NEW YEAR', 'CHRISTMAS', 'THANKSGIVING', 'EASTER'],
                answer: 'CHRISTMAS',
                difficulty: 'Advanced'
            }
        ]
    },
    {
        id: 'segment-3',
        title: 'The Last Request',
        stanzas: [5, 6],
        text: `Well, he seemed so low that I couldn't say no; then he says with a sort of moan:
"It's the cursèd cold, and it's got right hold till I'm chilled clean through to the bone.
Yet 'tain't being dead—it's my awful dread of the icy grave that pains;
So I want you to swear that, foul or fair, you'll cremate my last remains."

A pal's last need is a thing to heed, so I swore I would not fail;
And we started on at the streak of dawn; but God! he looked ghastly pale.
He crouched on the sleigh, and he raved all day of his home in Tennessee;
And before nightfall a corpse was all that was left of Sam McGee.`,
        morseText: '| | WELL HE SEEMED SO LOW THAT I COULDNT SAY NO THEN HE SAYS WITH A SORT OF MOAN BK ITS THE CURSED COLD AND ITS GOT RIGHT HOLD TILL IM CHILLED CLEAN THROUGH TO THE BONE BK YET TAINT BEING DEAD ITS MY AWFUL DREAD OF THE ICY GRAVE THAT PAINS SO I WANT YOU TO SWEAR THAT FOUL OR FAIR YOULL CREMATE MY LAST REMAINS BK | A PALS LAST NEED IS A THING TO HEED SO I SWORE I WOULD NOT FAIL AND WE STARTED ON AT THE STREAK OF DAWN BUT GOD HE LOOKED GHASTLY PALE BK HE CROUCHED ON THE SLEIGH AND HE RAVED ALL DAY OF HIS HOME IN TENNESSEE AND BEFORE NIGHTFALL A CORPSE WAS ALL THAT WAS LEFT OF SAM MCGEE BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'sam-mcgee-q2',
                question: 'What was Sam McGee\'s last request?',
                options: ['BURIAL AT SEA', 'CREMATION', 'RETURN TO TENNESSEE', 'GOLD CLAIM'],
                answer: 'CREMATION',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'segment-4',
        title: 'The Promise',
        stanzas: [7, 8],
        text: `There wasn't a breath in that land of death, and I hurried, horror-driven,
With a corpse half hid that I couldn't get rid, because of a promise given;
It was lashed to the sleigh, and it seemed to say: "You may tax your brawn and brains,
But you promised true, and it's up to you to cremate those last remains."

Now a promise made is a debt unpaid, and the trail has its own stern code.
In the days to come, though my lips were dumb, in my heart how I cursed that load.
In the long, long night, by the lone firelight, while the huskies, round in a ring,
Howled out their woes to the homeless snows—O God! how I loathed the thing.`,
        morseText: '| | THERE WASNT A BREATH IN THAT LAND OF DEATH AND I HURRIED HORROR DRIVEN WITH A CORPSE HALF HID THAT I COULDNT GET RID BECAUSE OF A PROMISE GIVEN BK IT WAS LASHED TO THE SLEIGH AND IT SEEMED TO SAY YOU MAY TAX YOUR BRAWN AND BRAINS BUT YOU PROMISED TRUE AND ITS UP TO YOU TO CREMATE THOSE LAST REMAINS BK | NOW A PROMISE MADE IS A DEBT UNPAID AND THE TRAIL HAS ITS OWN STERN CODE BK IN THE DAYS TO COME THOUGH MY LIPS WERE DUMB IN MY HEART HOW I CURSED THAT LOAD BK IN THE LONG LONG NIGHT BY THE LONE FIRELIGHT WHILE THE HUSKIES ROUND IN A RING HOWLED OUT THEIR WOES TO THE HOMELESS SNOWS O GOD HOW I LOATHED THE THING BK',
        estimatedSeconds: { wpm15: 185, wpm20: 138, wpm25: 111 },
        questions: [
            {
                id: 'sam-mcgee-q8',
                question: 'What phrase describes the trail\'s code?',
                options: ['SPEED IS KEY', 'PROMISE MADE IS DEBT UNPAID', 'GOLD OR BUST', 'SURVIVAL FIRST'],
                answer: 'PROMISE MADE IS DEBT UNPAID',
                difficulty: 'Advanced'
            }
        ]
    },
    {
        id: 'segment-5',
        title: 'Lake Lebarge',
        stanzas: [9, 10],
        text: `And every day that quiet clay seemed to heavy and heavier grow;
And on I went, though the dogs were spent and the grub was getting low;
The trail was bad, and I felt half mad, but I swore I would not give in;
And I'd often sing to the hateful thing, and it hearkened with a grin.

Till I came to the marge of Lake Lebarge, and a derelict there lay;
It was jammed in the ice, but I saw in a trice it was called the "Alice May."
And I looked at it, and I thought a bit, and I looked at my frozen chum;
Then "Here," said I, with a sudden cry, "is my cre-ma-tor-eum."`,
        morseText: '| | AND EVERY DAY THAT QUIET CLAY SEEMED TO HEAVY AND HEAVIER GROW AND ON I WENT THOUGH THE DOGS WERE SPENT AND THE GRUB WAS GETTING LOW BK THE TRAIL WAS BAD AND I FELT HALF MAD BUT I SWORE I WOULD NOT GIVE IN AND ID OFTEN SING TO THE HATEFUL THING AND IT HEARKENED WITH A GRIN BK | TILL I CAME TO THE MARGE OF LAKE LEBARGE AND A DERELICT THERE LAY BK IT WAS JAMMED IN THE ICE BUT I SAW IN A TRICE IT WAS CALLED THE ALICE MAY BK AND I LOOKED AT IT AND I THOUGHT A BIT AND I LOOKED AT MY FROZEN CHUM BK THEN HERE SAID I WITH A SUDDEN CRY IS MY CRE MA TOR E UM BK',
        estimatedSeconds: { wpm15: 185, wpm20: 138, wpm25: 111 },
        questions: [
            {
                id: 'sam-mcgee-q3',
                question: 'What was the name of the derelict ship?',
                options: ['ALICE MAY', 'LAKE LEBARGE', 'SAM MCGEE', 'TENNESSEE'],
                answer: 'ALICE MAY',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'segment-6',
        title: 'The Boiler Fire',
        stanzas: [11, 12],
        text: `Some planks I tore from the cabin floor, and I lit the boiler fire;
Some coal I found that was lying around, and I heaped the fuel higher;
The flames just soared, and the furnace roared—such a blaze you seldom see;
And I burrowed a hole in the glowing coal, and I stuffed in Sam McGee.

Then I made a hike, for I didn't like to hear him sizzle so;
And the heavens scowled, and the huskies howled, and the wind began to blow.
It was icy cold, but the hot sweat rolled down my cheeks, and I don't know why;
And the greasy smoke in an inky cloak went streaking down the sky.`,
        morseText: '| | SOME PLANKS I TORE FROM THE CABIN FLOOR AND I LIT THE BOILER FIRE BK SOME COAL I FOUND THAT WAS LYING AROUND AND I HEAPED THE FUEL HIGHER BK THE FLAMES JUST SOARED AND THE FURNACE ROARED SUCH A BLAZE YOU SELDOM SEE BK AND I BURROWED A HOLE IN THE GLOWING COAL AND I STUFFED IN SAM MCGEE BK | THEN I MADE A HIKE FOR I DIDNT LIKE TO HEAR HIM SIZZLE SO BK AND THE HEAVENS SCOWLED AND THE HUSKIES HOWLED AND THE WIND BEGAN TO BLOW BK IT WAS ICY COLD BUT THE HOT SWEAT ROLLED DOWN MY CHEEKS AND I DONT KNOW WHY BK AND THE GREASY SMOKE IN AN INKY CLOAK WENT STREAKING DOWN THE SKY BK',
        estimatedSeconds: { wpm15: 185, wpm20: 138, wpm25: 111 },
        questions: []
    },
    {
        id: 'segment-7',
        title: 'A Peep Inside',
        stanzas: [13, 14],
        text: `I do not know how long in the snow I wrestled with grisly fear;
But the stars came out and they danced about ere again I ventured near;
I was sick with dread, but I bravely said: "I'll just take a peep inside.
I guess he's cooked, and it's time I looked"; . . . then the door I opened wide.

And there sat Sam, looking cool and calm, in the heart of the furnace roar;
And he wore a smile you could see a mile, and he said: "Please close that door.
It's fine in here, but I greatly fear you'll let in the cold and storm—
Since I left Plumtree, down in Tennessee, it's the first time I've been warm."`,
        morseText: '| | I DO NOT KNOW HOW LONG IN THE SNOW I WRESTLED WITH GRISLY FEAR BK BUT THE STARS CAME OUT AND THEY DANCED ABOUT ERE AGAIN I VENTURED NEAR BK I WAS SICK WITH DREAD BUT I BRAVELY SAID ILL JUST TAKE A PEEP INSIDE BK I GUESS HES COOKED AND ITS TIME I LOOKED THEN THE DOOR I OPENED WIDE BK | AND THERE SAT SAM LOOKING COOL AND CALM IN THE HEART OF THE FURNACE ROAR BK AND HE WORE A SMILE YOU COULD SEE A MILE AND HE SAID PLEASE CLOSE THAT DOOR BK ITS FINE IN HERE BUT I GREATLY FEAR YOULL LET IN THE COLD AND STORM BK SINCE I LEFT PLUMTREE DOWN IN TENNESSEE ITS THE FIRST TIME IVE BEEN WARM BK',
        estimatedSeconds: { wpm15: 190, wpm20: 142, wpm25: 114 },
        questions: [
            {
                id: 'sam-mcgee-q4',
                question: 'Where did the narrator find Sam McGee at the end?',
                options: ['FROZEN IN SNOW', 'IN THE FURNACE', 'ON THE TRAIL', 'IN TENNESSEE'],
                answer: 'IN THE FURNACE',
                difficulty: 'Intermediate'
            },
            {
                id: 'sam-mcgee-q5',
                question: 'What did Sam ask the narrator to do when found alive?',
                options: ['OPEN THE DOOR', 'CLOSE THE DOOR', 'ADD MORE COAL', 'LET HIM OUT'],
                answer: 'CLOSE THE DOOR',
                difficulty: 'Intermediate'
            },
            {
                id: 'sam-mcgee-q7',
                question: 'What location is mentioned in Sam\'s hometown?',
                options: ['NASHVILLE', 'MEMPHIS', 'PLUMTREE', 'KNOXVILLE'],
                answer: 'PLUMTREE',
                difficulty: 'Advanced'
            }
        ]
    },
    {
        id: 'segment-8',
        title: 'The Tale Concludes',
        stanzas: [15],
        text: `There are strange things done in the midnight sun
By the men who moil for gold;
The Arctic trails have their secret tales
That would make your blood run cold;
The Northern Lights have seen queer sights,
But the queerest they ever did see
Was that night on the marge of Lake Lebarge
I cremated Sam McGee.`,
        morseText: '| | THERE ARE STRANGE THINGS DONE IN THE MIDNIGHT SUN BY THE MEN WHO MOIL FOR GOLD BK THE ARCTIC TRAILS HAVE THEIR SECRET TALES THAT WOULD MAKE YOUR BLOOD RUN COLD BK THE NORTHERN LIGHTS HAVE SEEN QUEER SIGHTS BUT THE QUEEREST THEY EVER DID SEE WAS THAT NIGHT ON THE MARGE OF LAKE LEBARGE I CREMATED SAM MCGEE BK',
        estimatedSeconds: { wpm15: 90, wpm20: 67, wpm25: 54 },
        questions: []
    }
];

export default {
    id: 'poem-cremation-sam-mcgee',
    type: 'poem',
    title: 'The Cremation of Sam McGee',
    author: 'Robert W. Service',
    publicationDate: '1907',
    coverImage: coverImg,
    genres: ['Narrative Poetry', 'Adventure', 'Yukon Gold Rush', 'Dark Humor'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A legendary Yukon Gold Rush poem about a prospector's macabre and humorous promise to cremate his friend in the freezing Arctic.",

    // Programmatic fields - NO REDUNDANCY
    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        collection: 'Songs of a Sourdough',
        setting: 'Yukon Territory, Canada',
        period: 'Klondike Gold Rush (1896-1899)',
        themes: ['Friendship', 'Promise-keeping', 'Survival', 'Irony', 'Death'],
        difficulty: 'Intermediate',
        estimatedReadingTimeMinutes: 5,
        stanzas: 15,
        rhymeScheme: 'AABB (couplets)'
    }
};
